import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {
    noContentElementInitialState,
    objectContentElementInitialState,
    paginatedArrayContentElementInitialState,
    printInitialState,
    updateState,
} from "../../../../common/utils/helpers";

const initialState = {
  consultationPackagesList: { ...paginatedArrayContentElementInitialState },
  historiquePackage: { ...objectContentElementInitialState },
  deletePackage: { ...noContentElementInitialState },
  print: {...printInitialState },
};

/*-------------------------------------------------CONSULTATION-PACKAGES----------------------------------------------------*/
const getConsultationPackagesList = (state) => {
  return updateState("consultationPackagesList", state, {
    ...paginatedArrayContentElementInitialState,
    isLoading: true,
  });
};

const getConsultationPackagesListSuccess = (
  state,
  { content, totalElements }
) => {
  return updateState("consultationPackagesList", state, {
    content,
    totalElements,
    isLoading: false,
    isSuccessed: true,
  });
};

const getConsultationPackagesListFail = (state, payload) => {
  return updateState("consultationPackagesList", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};
/*-------------------------------------------------HISTORIQUE-PACKAGE----------------------------------------------------*/
const getHistoriquePackage = (state) => {
  return updateState("historiquePackage", state, {
    ...objectContentElementInitialState,
    isLoading: true,
  });
};

const getHistoriquePackageSuccess = (state, payload) => {
  return updateState("historiquePackage", state, {
    content: payload,
    isLoading: false,
    isSuccessed: true,
  });
};

const getHistoriquePackageFail = (state, payload) => {
  return updateState("historiquePackage", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};

const getHistoriquePackageReinitialization = (state) => {
  return updateState("historiquePackage", state, {
    ...objectContentElementInitialState,
  });
};
/*-------------------------------------------------DELETE-PACKAGE----------------------------------------------------*/
const deletePackage = (state) => {
  return updateState("deletePackage", state, {
    ...noContentElementInitialState,
    isLoading: true,
  });
};

const deletePackageSuccess = (state) => {
  return updateState("deletePackage", state, {
    isLoading: false,
    isSuccessed: true,
  });
};

const deletePackageFail = (state, payload) => {
  return updateState("deletePackage", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};

const deletePackageFailReinitialization = (state) => {
  return updateState("deletePackage", state, {
    ...noContentElementInitialState,
  });
};
/*---------------------------------excel----------------------------------*/
const print = (state) => {
  return updateState("print", state, {
    ...printInitialState,
    isLoading: true,
  });
};

const printSuccess = (state, { content, type, fileName }) => {
  return updateState("print", state, {
    content,
    type,
    fileName,
    isLoading: false,
    isSuccessed: true,
  });
};

const printFail = (state, payload) => {
  return updateState("print", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};

const printReinitialization = (state) => {
  return updateState("print", state, {
    ...printInitialState,
  });
};

/*************************************************************************** */
const consultationPackagesReducer = (state = initialState, action) => {
  switch (action.type) {
    /*-------------------------------------------------CONSULTATION-PACKAGES----------------------------------------------------*/
    case ActionsTypes.GET_CONSULTATION_PACKAGES_LIST:
      return getConsultationPackagesList(state, action);
    case ActionsTypes.GET_CONSULTATION_PACKAGES_LIST_SUCCESS:
      return getConsultationPackagesListSuccess(state, action.payload);
    case ActionsTypes.GET_CONSULTATION_PACKAGES_LIST_FAIL:
      return getConsultationPackagesListFail(state, action.payload);
    /*-------------------------------------------------HISTORIQUE-PACKAGE----------------------------------------------------*/
    case ActionsTypes.GET_HISTORIQUE_PACKAGE:
      return getHistoriquePackage(state, action);
    case ActionsTypes.GET_HISTORIQUE_PACKAGE_SUCCESS:
      return getHistoriquePackageSuccess(state, action.payload);
    case ActionsTypes.GET_HISTORIQUE_PACKAGE_FAIL:
      return getHistoriquePackageFail(state, action.payload);
    case ActionsTypes.GET_HISTORIQUE_PACKAGE_REINITIALIZATION:
      return getHistoriquePackageReinitialization(state, action.payload);
    /*-------------------------------------------------DELETE-PACKAGE----------------------------------------------------*/
    case ActionsTypes.DELETE_PACKAGE:
      return deletePackage(state, action);
    case ActionsTypes.DELETE_PACKAGE_SUCCESS:
      return deletePackageSuccess(state);
    case ActionsTypes.DELETE_PACKAGE_FAIL:
      return deletePackageFail(state, action.payload);
    case ActionsTypes.DELETE_PACKAGE_REINITIALIZATION:
      return deletePackageFailReinitialization(state, action.payload);
    
     /*-------------------------------------------------Excel----------------------------------------------------*/
    
     case ActionsTypes.GENERAL_EXCEL_PACKAGE_EXPORT:
     return print(state, action.payload);
   case ActionsTypes.GENERAL_PRINT_PACKAGE_SUCCESS:
     return printSuccess(state, action.payload);
   case ActionsTypes.GENERAL_PRINT_PACKAGE_FAIL:
     return printFail(state);
   case ActionsTypes.GENERAL_PRINT_PACKAGE_REINITIALIZATION:
     return printReinitialization(state);    
      default:
      return state;
  }
};

export default consultationPackagesReducer;
